import * as $ from "jquery";
import { trackEvent } from "../../common/analytics";
import Environment from "../../common/environment";

let isJswSelected = false;
let isDevopsSelected = false;
const WAC_BASEURL = Environment.getWacIntegrationUrl();
const BB_BASEURL = Environment.getBBIntegrationUrl();
const INTERNATIONAL_SUBDIRECTORY = Environment.getInternationalSubdirectory();
const jswToggleWrapper = $(".bundle-jira-block");
const jswToggle = $(".bundle-jira-select-btn");
const jswToggleMobile = $(".bundle-jira-select-btn-mobile");
const jswToggleContent = jswToggle.find("span");
const showText = jswToggleContent.data("showtext");
const hideText = jswToggleContent.data("hidetext");

const devopsToggleWrapper = $(".bundle-devops-block");
const devopsToggle = $(".bundle-devops-select-btn");

const devopsToggleContent = devopsToggle.find("span");
const showTextDevops = devopsToggleContent.data("showtext");
const hideTextDevops = devopsToggleContent.data("hidetext");

const submitButton = $(".bundle-nxt-btn");

function listen() {
  jswToggle.on("click", function () {
    if (!isJswSelected) {
      jswToggleWrapper.addClass("active");
      jswToggle.addClass("active");
      jswToggleContent.text(hideText);
    } else {
      jswToggleWrapper.removeClass("active");
      jswToggle.removeClass("active");
      jswToggleContent.text(showText);
    }

    isJswSelected = !isJswSelected;
  });
  jswToggleMobile.on("click", function () {
    if (!isJswSelected) {
      jswToggleWrapper.addClass("active");
      jswToggleMobile.addClass("active");
      jswToggleContent.text(hideText);
    } else {
      jswToggleWrapper.removeClass("active");
      jswToggleMobile.removeClass("active");
      jswToggleContent.text(showText);
    }

    isJswSelected = !isJswSelected;
  });

  devopsToggle.on("click", function () {
    if (!isDevopsSelected) {
      devopsToggleWrapper.addClass("active");
      devopsToggle.addClass("active");
      devopsToggleContent.text(hideTextDevops);
    } else {
      devopsToggleWrapper.removeClass("active");
      devopsToggle.removeClass("active");
      devopsToggleContent.text(showTextDevops);
    }

    isDevopsSelected = !isDevopsSelected;
  });

  submitButton.on("click", function () {
    trackEvent("button clicked", { label: "Next" });
    let url = BB_BASEURL + `/account/signup?bundle=no`;

    if (isJswSelected) {
      let internationalSubdomain = INTERNATIONAL_SUBDIRECTORY
        ? `/${INTERNATIONAL_SUBDIRECTORY}`
        : "";
      url =
        WAC_BASEURL +
        internationalSubdomain +
        "/try/cloud/signup?bundle=jira-software-bitbucket&signupSource=bbbundle";
    }
    if (isDevopsSelected) {
      let internationalSubdomain = INTERNATIONAL_SUBDIRECTORY
        ? `/${INTERNATIONAL_SUBDIRECTORY}`
        : "";
      url =
        WAC_BASEURL +
        internationalSubdomain +
        "/try/cloud/signup?bundle=devops&signupSource=bbbundle";
    }

    window.location = url as any;
  });
}

listen();
